export default __webpack_public_path__ + "static/media/SunmiGreen.666862b7.svg";